class PasswordField {
  constructor(el) {
    this.el = el;
    this.$el = $(el);

    this.$input = this.$el.find('[data-password-field="input"]');
    this.$showIcon = this.$el.find('[data-password-icon="show-password"]');
    this.$hideIcon = this.$el.find('[data-password-icon="hide-password"]');

    this.onClickShowIcon = this.onClickShowIcon.bind(this);
    this.onClickHideIcon = this.onClickHideIcon.bind(this);

    this.bindEvents();

    window.grapp.instances = window.grapp.instances ? [...window.grapp.instances, this] : [this];
  }

  bindEvents() {
    this.$showIcon.on('click', this.onClickShowIcon);
    this.$hideIcon.on('click', this.onClickHideIcon);
  }

  onClickShowIcon(e) {
    e.preventDefault();
    this.$input.attr('type', 'text');
    this.$showIcon.hide();
    this.$hideIcon.show();
  }

  onClickHideIcon(e) {
    e.preventDefault();
    this.$input.attr('type', 'password');
    this.$hideIcon.hide();
    this.$showIcon.show();
  }

  static init() {
    $('[data-js-component="password-field"]').each((i, el) => new PasswordField(el));
  }
}

PasswordField.init();
